module.exports = __webpack_public_path__ + "media/images/dmu-text-dl-65d0e198924f7cb197f0684c52f8cded.jpg";